import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Track page view
export const trackPageView = async (page) => {
  try {
    await fetch(`${API_URL}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
        screen_width: window.screen.width,
        screen_height: window.screen.height
      })
    });
  } catch (err) {
    // Silent fail - don't impact user experience
    console.debug('Analytics tracking failed:', err);
  }
};

// Track a "bite" - user showing interest
export const trackBite = async (action, page, serviceType = null) => {
  try {
    await fetch(`${API_URL}/api/analytics/bite`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action,
        page,
        service_type: serviceType,
        user_agent: navigator.userAgent
      })
    });
  } catch (err) {
    console.debug('Bite tracking failed:', err);
  }
};

// Track OTP sent for follow-up
export const trackOTPSent = async (phoneNumber, requestType, name = null, email = null, serviceInterest = null) => {
  try {
    await fetch(`${API_URL}/api/analytics/otp-tracking`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone_number: phoneNumber,
        request_type: requestType,
        name,
        email,
        service_interest: serviceInterest
      })
    });
  } catch (err) {
    console.debug('OTP tracking failed:', err);
  }
};

// Analytics Provider Component - tracks page views automatically
const Analytics = () => {
  const location = useLocation();
  const lastTrackedPath = useRef('');

  useEffect(() => {
    // Only track if path changed (avoid double tracking on re-renders)
    if (location.pathname !== lastTrackedPath.current) {
      lastTrackedPath.current = location.pathname;
      trackPageView(location.pathname);
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default Analytics;
